<span class="inline-flex h-5 items-center rounded-full bg-gray-100 px-2 text-[10px] font-semibold uppercase text-gray-600">Optional</span>
